import { Configuration } from "@azure/msal-browser";
import { VITE_AZURE_AUTHORITY, VITE_AZURE_CLIENTID } from "./sys";

export const msalConfig: Configuration = {
  auth: {
    clientId: VITE_AZURE_CLIENTID!,
    authority: VITE_AZURE_AUTHORITY!,
    redirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

/**
 * MSAL login / silent-acquire scopes. Graph User.Read is fine for interactive login.
 * API Gateway authorizer auth uses the idToken from acquireTokenSilent (SPA audience),
 * not the Graph accessToken — see src/config/api.ts.
 */
export const loginRequest = {
  scopes: ["User.Read"],
};

export default msalConfig;
